import React from 'react'

const Manual_inventario_subrecetas = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
      <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Inventario - Subrecetas
      </h2>
      <p className="text-lg text-gray-700 mb-6">
        La guía ofrece un proceso simple para crear subrecetas en sistemas de inventario, crucial para una gestión eficiente de cocinas. Ayuda a optimizar el desarrollo de recetas, controlar el uso de ingredientes y mejorar la eficiencia en la producción culinaria. Es esencial para chefs y gerentes de cocina que buscan optimizar operaciones y controlar el inventario de manera precisa.
      </p>
      <iframe
        src="https://scribehow.com/embed/Inventario__Subrecetas__paeEQkrLTnyAuXSQehy5Ag?as=scrollable"
        className="scribe-iframe-general-43"
        width="100%"
        height="5850"
        allowFullScreen
        style={{ border: 0, minHeight: '640px' }}
      ></iframe>
    </div>
  </div>
  )
}

export default Manual_inventario_subrecetas